import React, { useEffect, useRef, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, ZoomControl } from "react-leaflet";
import { useMapEvents } from "react-leaflet";
import { useSelector, useDispatch } from "react-redux";
import { boundsActions } from "../../slice/map/bounds-slice";
import { placeActions } from "../../slice/map/place-slice";
import { listActions } from "../../slice/map/list-slice";
import L from "leaflet";
import { useGetAttractionsQuery, useGetExperiencesQuery } from "../../services/smartsenseApi";
import Place from "./Place";

import MarkerClusterGroup from "react-leaflet-cluster";

import utils from "../../utils/utils";
import "./style.css";
import { useParams } from "react-router-dom";

// afisarea unui placeholder pe harta cu locatia actuala a utilizatorului (trebuie apasat buton)
const CenterMap = () => {
    const [position, setPosition] = useState(null);
    const [bbox, setBbox] = useState([]);
    const map = useSelector((state) => state.place.map);

    useEffect(() => {
        if (!map) return;

        const customControlerGetMap = L.Control.extend({
            options: {
                position: "bottomright",
            },

            onAdd: function () {
                const btn = L.DomUtil.create("button");
                btn.title = "Home Button";
                btn.innerHTML =
                    "<svg class='MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root css-1om0hkc' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='AdjustIcon'><path d='M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z'></path></svg>";
                btn.className = "bg-[rgba(255,255,255,0.95)] h-8 px-1 rounded-full font-semibold text-base";

                btn.onclick = () => {
                    map.locate().on("locationfound", function (e) {
                        setPosition(e.latlng);
                        map.flyTo(e.latlng, map.getZoom());
                        setBbox(e.bounds.toBBoxString().split(","));
                    });

                    return position === null ? null : (
                        <Marker position={position} className="bg-black" icon={utils.changeColor("human")}>
                            <Popup>
                                Esti aici. <br />
                                Detalii locatie: <br />
                                <b>Sud-vest longitudine</b>: {bbox[0]} <br />
                                <b>Sud-vest latitudine</b>: {bbox[1]} <br />
                                <b>Nord-est longitudine</b>: {bbox[2]} <br />
                                <b>Nord-est latitudine</b>: {bbox[3]}
                            </Popup>
                        </Marker>
                    );
                };
                return btn;
            },
        });

        map.addControl(new customControlerGetMap());
    }, [map]);

    return null;
};

// afisarea in grid / satelit a hartii (trebuie apasat buton)
const ModeMap = () => {
    const map = useSelector((state) => state.place.map);
    const mapMode = useSelector((state) => state.list.toggleMapMod);
    const dispatch = useDispatch();
    const [valueMode, setValueMode] = useState(false);

    useEffect(() => {
        if (!map) return;

        const customControlerMapMode = L.Control.extend({
            options: {
                position: "bottomleft",
            },

            onAdd: function () {
                const btn = L.DomUtil.create("button");
                btn.title = "Grid / Satellite";
                btn.className = "bg-[rgba(255,255,255,0.95)] h-12 w-20 px-1 rounded-md font-semibold text-base";
                btn.innerHTML = "Grid / Satellite";

                btn.onclick = () => {
                    dispatch(listActions.toggleMapMode());
                };
                return btn;
            },
        });

        map.addControl(new customControlerMapMode());
    }, [map, valueMode]);
};

// functie ce actualizeaza in redux bounds-urile hartii cand utilizatorul schimba harta
function UpdatePlacesAndBounds() {
    const dispatch = useDispatch();
    const map = useMapEvents({
        moveend: () => {
            const bounds = map.getBounds();
            dispatch(boundsActions.updatePlaces(bounds));
            dispatch(boundsActions.updateExperiences());
        },
    });
    return null;
}

// functie care cere permisunea locatie utilizatorului
function LocationMarker() {
    const [position, setPosition] = useState(null);
    const [bbox, setBbox] = useState([]);
    const dispatch = useDispatch();

    const map = useMap();

    useEffect(() => {
        map.locate()
            .on("locationfound", function (e) {
                setPosition(e.latlng);
                dispatch(placeActions.getUserLocation(e.latlng));
                // map.flyTo(e.latlng, map.getZoom());
                // const radius = e.accuracy;
                // const circle = L.circle(e.latlng, radius);
                // circle.addTo(map);
                setBbox(e.bounds.toBBoxString().split(","));
            })
            .on("locationerror", function (e) {
                // map.flyTo({ lat: 45.2412834, lng: 27.9318981 });
            });
    }, [map]);

    return position === null ? null : (
        <Marker position={position} icon={utils.changeColor("human")}>
            <Popup>
                Esti aici. <br />
                Detalii locatie: <br />
                <b>Sud-vest longitudine</b>: {bbox[0]} <br />
                <b>Sud-vest latitudine</b>: {bbox[1]} <br />
                <b>Nord-est longitudine</b>: {bbox[2]} <br />
                <b>Nord-est latitudine</b>: {bbox[3]}
            </Popup>
        </Marker>
    );
}

const UpdateCenterMap = ({ lat, lng }) => {
    const map = useMap();
    useEffect(() => {
        map.setView([lat, lng], 14);
    }, [lat, lng]);

    return null;
};

function Map() {
    const dispatch = useDispatch();
    const { data: PointsOfInterest, isFetching: isFetchingPointsOfInterest, error: errorPointsOfInterest } = useGetAttractionsQuery();
    const { data: experiences, isFetching: isFetchingExperiences, error: errorExperiences } = useGetExperiencesQuery();
    const map = useSelector((state) => state.place.map);
    const searchInput = useSelector((state) => state.search.searchInput);
    const searchInputPoi = useSelector((state) => state.search.searchInputPoi);
    const newCenterMapLatitude = useSelector((state) => state.search.newCenterMapLat);
    const newCenterMapLogitude = useSelector((state) => state.search.newCenterMapLng);
    const mapMode = useSelector((state) => state.list.toggleMapMod);
    const refMapMode = useRef(null);

    // console.log(searchInput.length, searchInputPoi);

    // datele pentru harta tip grid
    const v1map = {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attr: "copy; <a href=https://www.openstreetmap.org/copyright>OpenStreetMap</a> contributors",
    };

    // datele pentru harta tip satelit
    const v2map = {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        attr: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
    };

    let lite_places = [];

    // verifica ce tip de harta a fost selectat in sesiunea aceasta daca se reface intrarea pe pagina din nou
    useEffect(() => {
        if (refMapMode.current) {
            refMapMode.current.setUrl(mapMode ? v1map.url : v2map.url);
        }
    }, [mapMode]);

    // incarcarea experientelor
    useEffect(() => {
        if (!isFetchingExperiences && !errorExperiences) {
            const experiente = experiences?.data;
            dispatch(boundsActions.updateAllLiteExperiences(experiente));
            console.log(experiences);
        }
    }, [isFetchingExperiences]);

    // incarcarea punctelor de interes cu campurile alese mai jos
    useEffect(() => {
        if (!isFetchingPointsOfInterest && !errorPointsOfInterest) {
            const punctele_de_interes = PointsOfInterest?.data;
            Object.keys(punctele_de_interes).forEach((place) => {
                lite_places.push({
                    id: punctele_de_interes[place].id,
                    title: punctele_de_interes[place].title,
                    experiences_length: punctele_de_interes[place].experiences.length,
                    image_url: punctele_de_interes[place]?.images[0]?.url,
                    point_of_interest_category: punctele_de_interes[place].point_of_interest_category,
                    latitude: punctele_de_interes[place].latitude,
                    longitude: punctele_de_interes[place].longitude,
                });
            });
            if (searchInput.length === 0) {
                dispatch(boundsActions.updateAllLitePlaces(punctele_de_interes));
                // console.log("toate punctele de interes");
            } else {
                dispatch(boundsActions.updateAllLitePlaces(searchInputPoi));
                console.log("cele din search", searchInputPoi);
                console.log(punctele_de_interes?.[0], searchInputPoi?.[0]);
            }

            if (map) {
                const bounds = map.getBounds();
                dispatch(boundsActions.updatePlaces(bounds));
            }
        }
    }, [isFetchingPointsOfInterest, searchInputPoi]);

    // incarcarea punctelor de interes
    useEffect(() => {
        if (!isFetchingPointsOfInterest && !errorPointsOfInterest && !isFetchingExperiences && !errorExperiences) {
            dispatch(boundsActions.updateExperiences());
        }
    }, [isFetchingPointsOfInterest, isFetchingExperiences]);

    // incarcarea hartii in redux
    const updateMapData = (map) => {
        dispatch(placeActions.getMap(map));
    };
    return (
        <MapContainer
            center={[45.2412834, 27.9318981]}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
            zoomControl={false}
            ref={updateMapData}>
            <ZoomControl position="bottomright" />
            <TileLayer
                ref={refMapMode}
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url={mapMode ? v1map.url : v2map.url}
            />
            <UpdatePlacesAndBounds />
            <MarkerClusterGroup chunkedLoading>
                {PointsOfInterest?.data.map((place, index) => (
                    <Marker
                        key={index}
                        position={[place.latitude, place.longitude]}
                        title={place.title}
                        icon={L.divIcon({
                            html: `<svg style='fill:${place.point_of_interest_category.color}' class='MuiSvgIcon-fontSizeMedium MuiBox-root css-uqopch' focusable='false' aria-hidden='true' viewBox='0 0 24 24' data-testid='FmdGoodIcon'><path d='M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z'></path></svg>`,
                            className: "w-full h-full",
                            iconSize: [40, 54],
                            iconAnchor: [12, 30],
                        })}
                        eventHandlers={{
                            click: () => dispatch(listActions.statusPlaceList(place)),
                        }}>
                        <Popup autoPan={false}>
                            <Place place={place} key={index} onLocation={"map"} />
                        </Popup>
                    </Marker>
                ))}
            </MarkerClusterGroup>
            <CenterMap />
            <ModeMap />
            <LocationMarker />
            {newCenterMapLatitude !== null && newCenterMapLogitude !== null && (
                <UpdateCenterMap lat={newCenterMapLatitude} lng={newCenterMapLogitude} />
            )}
        </MapContainer>
    );
}

export default Map;
